import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGraduationHat = () => {
  return (
    <g>
      <path d="m15.5341 5.5032-7.1768-3.25a.75.75 0 0 0 -.5967-.01l-7.2724 3.0105a.75.75 0 0 0 -.4629.6929c0 .3547.0131.4552 3.0049 1.835v3.8491a.7478.7478 0 0 0 .1475.4458c.78 1.0552 2.6934 1.7368 4.874 1.7368a6.56 6.56 0 0 0 4.7266-1.5561.75.75 0 0 0 .1914-.5v-3.8261l.78-.3229v2.3486a.75.75 0 1 0 1.5 0v-2.9693l.2617-.1083a.75.75 0 0 0 .0225-1.376zm-4.0644 5.93a5.8766 5.8766 0 0 1 -3.418.88 5.5877 5.5877 0 0 1 -3.5217-.9663v-2.8789c.8657.394 1.88.8534 3.1123 1.4112a.75.75 0 0 0 .5967.01l3.23-1.337zm-3.5039-3.0545c-.8858-.4009-3.5625-1.6128-5.3037-2.4009l5.372-2.2237 5.3037 2.4014z" />
    </g>
  );
};

export default withIcon(IconGraduationHat);
